export const SET_ALBARANES = "SET_ALBARANES";
export const SET_CAMIONES = "SET_CAMIONES";
export const SET_OBRAS = "SET_OBRAS";
export const SET_TIPOS = "SET_TIPOS";
export const SET_VERTEDEROS = "SET_VERTEDEROS";

export const SET_ALBARAN_PENDIENTE = "SET_ALBARAN_PENDIENTE";

export const SET_CARTAS_PORTE = "SET_CARTAS_PORTE";
export const SET_CARTA_PORTE_PENDIENTE = "SET_CARTA_PORTE_PENDIENTE";
export const SET_MAQUINAS = "SET_MAQUINAS";
export const SET_PLANTAS_ARIDO = "SET_PLANTAS_ARIDO";
